/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class KpiMetricAggregate {
    getFixupPrototypeFunction() { return KpiMetricAggregate.fixupPrototype; }

    static newInstance(model: Partial<KpiMetricAggregate>): KpiMetricAggregate {
        let obj = Object.assign(new KpiMetricAggregate(), model);
        KpiMetricAggregate.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<KpiMetricAggregate>): KpiMetricAggregate {
        if (!model) return null;
        return KpiMetricAggregate.newInstance(<KpiMetricAggregate> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: KpiMetricAggregate) {
        if (!obj) return;

        models.KpiMetricAggregate.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: KpiMetricAggregate): boolean {
        Object.setPrototypeOf(obj, KpiMetricAggregate.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.cpu_utilization) {
            for (let val of this.cpu_utilization) {
                models.MetricDetailedData.fixupPrototype(val);
            }
        }
        if (this.memory_utilization) {
            for (let val of this.memory_utilization) {
                models.MetricDetailedData.fixupPrototype(val);
            }
        }
        if (this.disk_space_utilization) {
            for (let val of this.disk_space_utilization) {
                models.DiskUtilizationBatchResponse.fixupPrototype(val);
            }
        }
    }

    /**
     * Statistics about the CPU Utilization.
     */
    cpu_utilization: Array<models.MetricDetailedData>;

    /**
     * Statistics about the Memory Utilization.
     */
    memory_utilization: Array<models.MetricDetailedData>;

    /**
     * Statistics about the Disk Space Utilization.
     */
    disk_space_utilization: Array<models.DiskUtilizationBatchResponse>;

}
